var React = require('react');

function UiChevronThin (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Chevron Thin"),React.createElement("path",{"d":"M10.52,11.09l.89-.76L21,2.09,19.26,0,10.52,7.48,1.78,0,0,2.09l9.63,8.24Z","key":1})]);
}

UiChevronThin.defaultProps = {"viewBox":"0 0 21.04 11.09"};

module.exports = UiChevronThin;

UiChevronThin.default = UiChevronThin;
